import React, { VFC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { ThemePageCard } from '../pages/Top';
import {
  HomeMediaCard,
  HOME_MEDIA_DEFAULT_MEDIA_PADDING_TOP,
  clampedTextBlock,
} from '../components/home/cards';

type Props = ThemePageCard & {
  className?: string;
};

const Card: VFC<Props> = ({
  headline,
  slug,
  cardImageUrl,
  headerImageUrl,
  className,
}) => {
  const classes = useStyles();
  const imageUrl = cardImageUrl || headerImageUrl;

  return (
    <HomeMediaCard
      href={`/theme/${slug}`}
      className={clsx(classes.root, className)}
      elevated
      imageUrl={imageUrl}
      imageAlt={headline}
      mediaAspectPaddingTop={HOME_MEDIA_DEFAULT_MEDIA_PADDING_TOP}
    >
      <p className={classes.title}>{headline}</p>
    </HomeMediaCard>
  );
};

export default Card;

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiCardActionArea-root:hover': {
      opacity: 0.8,
    },
  },
  title: {
    fontWeight: 'bold',
    margin: 0,
    marginBottom: theme.spacing(0.5),
    ...clampedTextBlock(theme, 2, { xs: 14, sm: 16 }),
  },
}));
